import script from "./RemoteAreas.vue?vue&type=script&setup=true&lang=js"
export * from "./RemoteAreas.vue?vue&type=script&setup=true&lang=js"

import "./RemoteAreas.vue?vue&type=style&index=0&id=5b9a49f8&lang=css"

const __exports__ = script;

export default __exports__